import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import QuestLeaderboard from './QuestLeaderboard';
import QuestDataReset from './QuestDataReset';
import SubscriptionManagement from './SubscriptionManagement';
import './QuestAuditIndex.scss';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`quest-audit-tabpanel-${index}`}
      aria-labelledby={`quest-audit-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className="tab-panel-content">
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `quest-audit-tab-${index}`,
    'aria-controls': `quest-audit-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#1b1b24',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  },
  tabBar: {
    backgroundColor: '#252530',
    color: 'white',
    boxShadow: 'none',
  },
  tab: {
    minWidth: 150,
    fontWeight: 500,
    fontSize: '16px',
    textTransform: 'none',
    '&.Mui-selected': {
      color: '#ff5a5f',
    },
  },
  indicator: {
    backgroundColor: '#ff5a5f',
    height: 3,
  },
}));

export default function QuestAuditIndex(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={`admin-quest-audit-tab-container ${classes.root}`}>
      <AppBar position="static" className={classes.tabBar}>
        <Tabs value={value} onChange={handleChange} aria-label="quest audit tabs">
          <Tab label="排行榜详情" {...a11yProps(0)} />
          <Tab label="数据重排" {...a11yProps(1)} />
          <Tab label="权限订阅" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <QuestLeaderboard {...props} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <QuestDataReset {...props} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <SubscriptionManagement {...props} />
      </TabPanel>
    </div>
  );
}